import React from 'react';
import { SvgImage } from '.';
import { InfoIconNew, OpenInNewWindow, tipsIcon1 } from '../../style/images';
import { getProductLink } from '../util';
import { PropTypes } from 'prop-types';
import { Box} from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useSelector } from 'react-redux';

const ProductLinkComponent = ( { title, name, properties } ) => {
  const label = title;

  const screenSize = useSelector(state=>state.screenSize)
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#464646",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#464646",
    },
  }));

  return <div className="product-link">
    <span className="ellipsed" title={ properties && label }>{ properties && label }</span>
    <Box sx={{display:{md:"flex", xs:"none"}}}>
    <div className="product-link-icons-panel">
      <a href={ getProductLink( name ) } target="_blank">
        <Box component="img" src={ OpenInNewWindow }/>
      </a>
      {/* <div className="product-code-icon" title={ name } style={{background:"white"}}> */}
      <BootstrapTooltip title={name}>
      <Box component="img" src={InfoIconNew}>

      </Box>
      </BootstrapTooltip>
      {/* </div> */}
    </div>
    </Box>
    <Box sx={{display:{md:"none", xs:"flex"}}}>
      <div className="product-link-icons-panel">
        <div className='option-icon'>
          <a href={ getProductLink( name ) } target="_blank">
            <Box component="img" src={ OpenInNewWindow }/>
          </a>
        </div>
        {/* <div className="product-code-icon" title={ name } style={{background:"white"}}> */}
        {screenSize.width>900 && <div className='option-icon'>
        <BootstrapTooltip title={name}>
        <Box component="img" src={InfoIconNew}>

        </Box>
        </BootstrapTooltip>
        </div>}
        {/* </div> */}
      </div>
    </Box>
  </div>;
};

ProductLinkComponent.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  properties: PropTypes.shape( {} )
};
export const ProductLink = ProductLinkComponent;